// Customer & Addresses mock data (approved HTML:
// 14-Customer-Addresses-Consistency-Review-v5.html). Draft-order-only
// address changes must not alter the customer default or any other
// subscription; the Scope radio captures that.

export interface SavedAddress {
  id: string;
  label: string;
  recipient: string;
  line1: string;
  city: string;
  state: string;
  zip: string;
  current: boolean;
}

export interface SubscriptionTarget {
  id: string;
  label: string;
}

export const CUSTOMER_FORM = {
  first: 'Sarah',
  last: 'Mitchell',
  email: 'sarah.mitchell@example.com',
  phone: '(615) 555-0148',
  customerId: 'C-1048',
};

export const SAVED_ADDRESSES: SavedAddress[] = [
  {
    id: 'addr_barn',
    label: 'Barn address',
    recipient: 'Sarah Mitchell',
    line1: '2401 Smith Spring Rd',
    city: 'Nashville',
    state: 'TN',
    zip: '37206',
    current: true,
  },
  {
    id: 'addr_home',
    label: 'Home address',
    recipient: 'Sarah Mitchell',
    line1: '144 Belle Meade Blvd',
    city: 'Nashville',
    state: 'TN',
    zip: '37205',
    current: false,
  },
];

export const SUBSCRIPTIONS: SubscriptionTarget[] = [
  { id: 'barn-plan', label: 'Barn supplements · Next Oct 15' },
  { id: 'hydration-plan', label: 'Hydration · Next Oct 28' },
];

export const SCOPE_LABELS = {
  order: {
    heading: 'Only draft order #D-1048 changes.',
    detail:
      'The customer default and every subscription keep their current addresses.',
  },
  default: {
    heading: 'The customer default changes for future orders.',
    detail: 'Existing orders and subscription schedules keep their current addresses.',
  },
  subscription: {
    heading: 'Only the selected subscription changes.',
    detail: 'Draft order #D-1048 and the customer default keep their current addresses.',
  },
};
